/**
 * A run's state on a definition's Runs tab: FILLED (`.status-badge`), so it
 * never reads as a definition's outlined `.def-badge` change state.
 */

import type { ReactElement } from 'react';
import type { RunRowState } from '../utils/runRowState';

const LABELS: Record<RunRowState, string> = {
  running: 'running',
  gate_red: 'gate still red',
  mr_green: 'MR green',
  mr_running: 'MR pipeline running',
  mr_open: 'MR open',
  mr_merged: 'MR merged',
  mr_closed: 'MR closed',
  pushed: 'branch pushed',
  no_change: 'no change',
  failed: 'failed',
  denied: 'denied',
  stopped: 'stopped',
  expired: 'expired',
  not_dispatched: 'not dispatched',
};

export function RunRowBadge({ state }: { state: RunRowState }): ReactElement {
  return (
    <span className={`status-badge status-badge--row-${state}`}>
      {state === 'running' && <span className="status-badge__spinner" />}
      {LABELS[state]}
    </span>
  );
}
